import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = {
  class: "tab-content",
  id: "myTabContent7"
}
const _hoisted_4 = {
  class: "tab-pane fade",
  id: "code7-tab-pane",
  role: "tabpanel",
  "aria-labelledby": "code7-tab",
  tabindex: "0"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("h4", { class: "fs-18 mb-4" }, "Dismissing Alerts", -1)),
      _cache[4] || (_cache[4] = _createElementVNode("ul", {
        class: "nav nav-tabs mb-4",
        id: "myTab7",
        role: "tablist"
      }, [
        _createElementVNode("li", {
          class: "nav-item",
          role: "presentation"
        }, [
          _createElementVNode("button", {
            class: "nav-link active",
            id: "preview7-tab",
            "data-bs-toggle": "tab",
            "data-bs-target": "#preview7-tab-pane",
            type: "button",
            role: "tab",
            "aria-controls": "preview7-tab-pane",
            "aria-selected": "true"
          }, " Preview ")
        ]),
        _createElementVNode("li", {
          class: "nav-item",
          role: "presentation"
        }, [
          _createElementVNode("button", {
            class: "nav-link",
            id: "code7-tab",
            "data-bs-toggle": "tab",
            "data-bs-target": "#code7-tab-pane",
            type: "button",
            role: "tab",
            "aria-controls": "code7-tab-pane",
            "aria-selected": "false"
          }, " Code ")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _cache[2] || (_cache[2] = _createElementVNode("div", {
          class: "tab-pane fade show active",
          id: "preview7-tab-pane",
          role: "tabpanel",
          "aria-labelledby": "preview7-tab",
          tabindex: "0"
        }, [
          _createElementVNode("div", {
            class: "alert alert-primary alert-dismissible",
            role: "alert"
          }, [
            _createTextVNode(" A simple primary alert—check it out! "),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close shadow-none",
              "data-bs-dismiss": "alert",
              "aria-label": "Close"
            })
          ]),
          _createElementVNode("div", {
            class: "alert alert-secondary alert-dismissible",
            role: "alert"
          }, [
            _createTextVNode(" A simple secondary alert—check it out! "),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close shadow-none",
              "data-bs-dismiss": "alert",
              "aria-label": "Close"
            })
          ]),
          _createElementVNode("div", {
            class: "alert alert-success alert-dismissible",
            role: "alert"
          }, [
            _createTextVNode(" A simple success alert—check it out! "),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close shadow-none",
              "data-bs-dismiss": "alert",
              "aria-label": "Close"
            })
          ]),
          _createElementVNode("div", {
            class: "alert alert-danger alert-dismissible",
            role: "alert"
          }, [
            _createTextVNode(" A simple danger alert—check it out! "),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close shadow-none",
              "data-bs-dismiss": "alert",
              "aria-label": "Close"
            })
          ]),
          _createElementVNode("div", {
            class: "alert alert-warning alert-dismissible",
            role: "alert"
          }, [
            _createTextVNode(" A simple warning alert—check it out! "),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close shadow-none",
              "data-bs-dismiss": "alert",
              "aria-label": "Close"
            })
          ]),
          _createElementVNode("div", {
            class: "alert alert-info alert-dismissible",
            role: "alert"
          }, [
            _createTextVNode(" A simple info alert—check it out! "),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close shadow-none",
              "data-bs-dismiss": "alert",
              "aria-label": "Close"
            })
          ]),
          _createElementVNode("div", {
            class: "alert alert-light alert-dismissible",
            role: "alert"
          }, [
            _createTextVNode(" A simple light alert—check it out! "),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close shadow-none",
              "data-bs-dismiss": "alert",
              "aria-label": "Close"
            })
          ]),
          _createElementVNode("div", {
            class: "alert alert-dark alert-dismissible",
            role: "alert"
          }, [
            _createTextVNode(" A simple dark alert—check it out! "),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close shadow-none",
              "data-bs-dismiss": "alert",
              "aria-label": "Close"
            })
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.copyCode && _ctx.copyCode(...args)))
          }, " Copy "),
          _cache[1] || (_cache[1] = _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
            _createTextVNode(""),
            _createElementVNode("code", {
              class: "language-markup",
              id: "basicAlertsCode7"
            }, "\n<div class=\"alert alert-primary alert-dismissible\" role=\"alert\">\n  A simple primary alert—check it out!\n  <button type=\"button\" class=\"btn-close shadow-none\" data-bs-dismiss=\"alert\" aria-label=\"Close\"></button>\n</div>\n<div class=\"alert alert-secondary alert-dismissible\" role=\"alert\">\n  A simple secondary alert—check it out!\n  <button type=\"button\" class=\"btn-close shadow-none\" data-bs-dismiss=\"alert\" aria-label=\"Close\"></button>\n</div>\n<div class=\"alert alert-success alert-dismissible\" role=\"alert\">\n  A simple success alert—check it out!\n  <button type=\"button\" class=\"btn-close shadow-none\" data-bs-dismiss=\"alert\" aria-label=\"Close\"></button>\n</div>\n<div class=\"alert alert-danger alert-dismissible\" role=\"alert\">\n  A simple danger alert—check it out!\n  <button type=\"button\" class=\"btn-close shadow-none\" data-bs-dismiss=\"alert\" aria-label=\"Close\"></button>\n</div>\n<div class=\"alert alert-warning alert-dismissible\" role=\"alert\">\n  A simple warning alert—check it out!\n  <button type=\"button\" class=\"btn-close shadow-none\" data-bs-dismiss=\"alert\" aria-label=\"Close\"></button>\n</div>\n<div class=\"alert alert-info alert-dismissible\" role=\"alert\">\n  A simple info alert—check it out!\n  <button type=\"button\" class=\"btn-close shadow-none\" data-bs-dismiss=\"alert\" aria-label=\"Close\"></button>\n</div>\n<div class=\"alert alert-light alert-dismissible\" role=\"alert\">\n  A simple light alert—check it out!\n  <button type=\"button\" class=\"btn-close shadow-none\" data-bs-dismiss=\"alert\" aria-label=\"Close\"></button>\n</div>\n<div class=\"alert alert-dark alert-dismissible\" role=\"alert\">\n  A simple dark alert—check it out!\n  <button type=\"button\" class=\"btn-close shadow-none\" data-bs-dismiss=\"alert\" aria-label=\"Close\"></button>\n</div>\n"),
            _createTextVNode("\n")
          ], -1))
        ])
      ])
    ])
  ]))
}